import { BigNumberish } from 'ethers'
import { Factory } from '@/constants/contract/contractTypes'

export const feeCall = (contract: Factory) => {
  return contract.fee()
}

export interface BurnCallParams {
  contract: Factory
  tokenAddress: string
  amount: BigNumberish
  receiverAddress: string
  fee: BigNumberish
}

export const burnCall = async ({ contract, tokenAddress, amount, receiverAddress, fee }: BurnCallParams) => {
  const tx = await contract.burn(tokenAddress, amount, receiverAddress, { value: fee })
  return tx.wait(1)
}

export interface MintCallParams {
  contract: Factory
  tokenAddress: string
  receiverAddress: string
  amount: BigNumberish
  txid: string
  v: string[]
  r: string[]
  s: string[]
}

export const mintCall = async ({ contract, tokenAddress, receiverAddress, amount, txid, v, r, s }: MintCallParams) => {
  const tx = await contract.mint(tokenAddress, receiverAddress, amount, txid, v, r, s)
  return tx.wait(1)
}
